skrilla.controller('manualUpdateCsgoTeamScoresCtrl', function ($scope, cacheService) {
    $scope.team = cacheService.getObject("updateCsgoTeam");
});